export default value => {
    return typeof value !== 'undefined';
};
